import qs from "qs";
import { connect } from "react-redux";
import React, { Component } from "react";
import * as MabnaButton from "./Button/Button";
import Pagination from "react-js-pagination";
import { Field, reduxForm, reset, getFormValues } from "redux-form";

import { Checkbox, CheckboxGroup } from "./CheckboxGroup";
import { debounce } from "../../helpers/utility";

const defaultItemsPerPage = 25;

class SearchAndQueryBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // collapsed: true,
      activePage: 1
    };
  }

  createSearchField = ({ input, name, placeholder, type = "text" }) => (
    <input
      {...input}
      onChange={this.onChangeEnhancer(input.onChange)}
      name={name}
      type={type}
      style={{ padding: 5, height: 40 }}
      placeholder={placeholder}
    />
  );

  getSearchOptionsName = () => {
    const { searchOptions = [] } = this.props;
    return searchOptions.map(option => option.name);
  };

  handleSubmit = values => {
    // values come from redux-form or some other way
    const searchOptionsNames = this.getSearchOptionsName();

    // check if user is searching
    for (const key in values) {
      if (values.hasOwnProperty(key)) {
        if (searchOptionsNames.indexOf(key) !== -1) {
          // user has entered something in the search box
          this.setState({ activePage: 1 });
        }
      }
    }

    // gather all parameters
    const toBeStringified = {
      ...values,
      // in some cases there is a constant query that needs to be present in all queries
      ...this.props.attachConstantQuery,
      page: this.state.activePage
    };

    const queryString = qs.stringify(toBeStringified, {
      encode: false,
      indices: false
    });

    this.props.dispatch({
      type: this.props.actionType,
      queryString: queryString,
      ...this.props.additionalDispatchProperty
    });
  };

  debouncedSubmit = debounce(
    () => this.handleSubmit(this.getCurrentFormValues()),
    450
  );

  onRemoveQuery = () => {
    this.props.dispatch(reset("SearchAndQueryBar"));
    this.props.dispatch({
      type: this.props.actionType,
      queryString: "page=1",
      ...this.props.additionalDispatchProperty
    });
  };

  getCurrentFormValues = () => {
    const { formValues } = this.props;
    return formValues ? formValues : {};
  };

  handlePageChange = nextPage => {
    // very important: pass setState a callback, otherwise it wont work correctly
    this.setState({ activePage: nextPage }, () =>
      this.handleSubmit(this.getCurrentFormValues())
    );
  };

  renderCollapseButton = () => (
    <div>
      <MabnaButton.Primary
        outline
        style={{ margin: "0" }}
        onClick={() => this.setState({ collapsed: false })}
      >
        اعمال فیلتر و جستجو
      </MabnaButton.Primary>
    </div>
  );

  renderQueryCheckboxes = () => {
    const { noQuery } = this.props;

    if (noQuery) {
      return <div />;
    }

    return this.props.queryOptions.map(queryGroup => {
      const { name, options, label } = queryGroup;
      return (
        <div className="query-option-group" key={queryGroup.name}>
          <div className="query-option-group-title">{label}</div>

          <div className="query-options-container">
            <Field
              component={this.checkboxGroupRenderer}
              name={name}
              options={options}
            />
          </div>
        </div>
      );
    });
  };

  checkboxGroupRenderer = ({ options, input, name }) => {
    const checkboxes = options.map(({ name: label, value }, index) => {
      return (
        <Checkbox
          value={String(value)}
          key={index}
          wrapperClass="query-option"
          label={label}
        />
      );
    });

    const checkboxGroupValue = input.value || [];

    return (
      <CheckboxGroup
        onChange={this.onChangeEnhancer(input.onChange)}
        value={checkboxGroupValue}
        key={name}
      >
        {checkboxes}
      </CheckboxGroup>
    );
  };

  onChangeEnhancer = onChange => newValue => {
    onChange(newValue);
    this.debouncedSubmit();
  };

  renderSearchFields = () => {
    if (!this.props.searchOptions) {
      return (
        <Field
          name="search"
          placeholder="جستجو"
          component={this.createSearchField}
        />
      );
    }

    return this.props.searchOptions.map(option => (
      <Field
        key={option.name}
        name={option.name}
        placeholder={option.label}
        component={this.createSearchField}
        type={option.type}
        {...option.props}
      />
    ));
  };

  renderActionButtons = () => (
    <div>
      {/* Fatemi wants the filters to act automatically without
      any user request so the submit button is not needed */}
      <MabnaButton.Primary
        className="search-and-query-toggle-button"
        style={{ margin: "0" }}
        onClick={this.onRemoveQuery}
        outline
      >
        بازنشاندن فیلتر ها
      </MabnaButton.Primary>
    </div>
  );

  renderPagination = () => {
    const countThreshold = this.props.itemsPerPage || defaultItemsPerPage;

    if (this.props.itemsCount > countThreshold) {
      return (
        <Pagination
          activePage={this.state.activePage}
          itemsCountPerPage={countThreshold}
          totalItemsCount={this.props.itemsCount}
          pageRangeDisplayed={10}
          onChange={this.handlePageChange}
          itemClass="pagination-item"
          innerClass="pagination"
        />
      );
    }

    return <div />;
  };

  /*
  sample queryOptions:
  array of objects
  [
    {
       name: "xxx",
       options: [
        {name: value},
        {name: value},
        {name: value},
        ...
      ]
    }
  ]
  */

  render() {
    const { handleSubmit, hidePagination, hideQueryOptions } = this.props;
    // const shouldBeCollapsed = this.state.collapsed && this.props.collapsed

    return (
      <div
        className={`search-and-query ${hideQueryOptions ? "no-query" : ""}`}
        style={this.props.style || {}}
      >
        {!hideQueryOptions && (
          <div className="search-and-query__queries">
            {/* Query elements */}

            {/* {shouldBeCollapsed ? (
              this.renderCollapseButton()
            ) : ( */}

            <form
              ref={form => (this.queryForm = form)}
              onSubmit={handleSubmit(this.handleSubmit)}
              className="query-form"
            >
              {/* search fields */}
              {this.renderSearchFields()}

              {/* query checkbox groups */}
              {this.renderQueryCheckboxes()}

              {/* action buttons */}
              {this.renderActionButtons()}
            </form>

            {/* )} */}
          </div>
        )}

        {/* Child Element + Pagination */}
        <div className="search-and-query__content query-able-child">
          {/* child element that this component renders */}
          <div id={this.props.innerId ? this.props.innerId : ""}>
            {this.props.children}
          </div>

          {/* pagination */}
          {!hidePagination && (
            <div style={{ display: "flex", justifyContent: "center" }}>
              {this.renderPagination()}
            </div>
          )}
        </div>
      </div>
    );
  }
}

SearchAndQueryBar = reduxForm({
  form: "SearchAndQueryBar"
})(SearchAndQueryBar);

const mapStateToProps = state => {
  return {
    formValues: getFormValues("SearchAndQueryBar")(state)
  };
};

export default connect(mapStateToProps)(SearchAndQueryBar);



// WEBPACK FOOTER //
// ./src/components/common/SearchAndQueryBar.js